<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Fotoğraf Galerisi</b-card-title>
      <div>
        <b-button
            variant="primary"
            class="mr-1"
            @click="setModal('products-gallery')"
        >
          <FeatherIcon icon="UploadIcon" />
          Fotoğraf Yükle
        </b-button>
        <b-button
            variant="success"
            class="mr-1"
            @click="triggerBulkUpload"
        >
          <FeatherIcon icon="UploadIcon" />
          Toplu Fotoğraf Yükle
        </b-button>
        <b-form-file
            ref="bulkFileInput"
            v-model="bulkFiles"
            multiple
            accept="image/*"
            class="d-none"
            @change="handleBulkFilesChange"
        />
      </div>
    </b-card-header>
    <b-card-body>
      <div
          v-if="dataItem.images.length > 0"
      >
        <draggable
            v-model="images"
            tag="ul"
            class="cursor-move p-0 row match-height"
        >
          <div
              v-for="(image, index) in images"
              :key="index"
              tag="li"
              class="col-auto col-md-3"
          >
            <div
                class="border-light rounded p-1 mb-2"
                :class="image.id? 'bg-light-primary' : 'bg-light-warning'"
            >
              <div
                  class="height-auto overflow-hidden"
                  :class="image.id? 'bg-light-primary' : 'bg-light-warning'"
              >
                <b-img
                    :src="imageUrl + '/media/product_media/' + image.thumb"
                    fluid
                    class="h-auto w-100"
                />
                <b-form-input
                    v-model="image.title"
                    size="sm"
                    class="mt-1"
                    placeholder="Görsel Açıklama"
                />
              </div>
              <div class="border-top mt-1 d-flex justify-content-around">
                <b-button
                    variant="outline-success"
                    size="sm"
                    pill
                    class="btn-icon mt-1"
                    :disabled="!image.id"
                    @click="saveImage(image)"
                >
                  <FeatherIcon icon="CheckIcon" />
                </b-button>
                <b-button
                    variant="outline-danger"
                    size="sm"
                    pill
                    class="btn-icon mt-1"
                    @click="removeImage(image,index)"
                >
                  <FeatherIcon icon="TrashIcon" />
                </b-button>
              </div>
            </div>
          </div>
        </draggable>
        <b-alert
            show
            variant="info"
        >
          <div class="alert-body text-center">
            <FeatherIcon icon="InfoIcon" /> Fotoğrafları sıralamak için sürükleyin.
          </div>
        </b-alert>
        <hr>
      </div>
    </b-card-body>
    <cropper-image
        v-if="cropperSettings.type"
        :modal-status="cropperSettings.modalStatus"
        :close-modal="closeModal"
        :file-name="cropperSettings.fileName"
        :folder="cropperSettings.folder"
        :ratio="cropperSettings.ratio"
        :width-size="cropperSettings.widthSize"
        :current-file="cropperSettings.currentFile"
        :is-bulk="cropperSettings.isBulk"
        :bulk-progress="cropperSettings.bulkProgress"
        @uploadImage="handleUploadImage"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BImg, BButton, BAlert, BFormInput, BFormFile,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'PhotoGallery',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BImg,
    BButton,
    BFormInput,
    BFormFile,
    BAlert,
    draggable,
    CropperImage,
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      images: [],
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
      bulkFiles: [],
      bulkUploadQueue: [],
      currentBulkIndex: 0,
      isBulkUploading: false,
      bulkUploadInProgress: false,
    }
  },
  computed: {
    dataItem() {
      const data = this.$store.getters['productGroups/dataItem']
      if (data) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.images = data.images
      }
      return data
    },
  },
  watch: {
    images() {
      this.$store.dispatch('productGroups/reOrderingImages', this.images)
    },
  },
  methods: {
    setModal(type) {
      if (type === 'products-gallery') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'products-post-image.jpg',
          folder: 'product_media',
          ratio: 800 / 1200,
          widthSize: 800,
          type: 'products-gallery',
        }
      }
    },
    closeModal() {
      if (this.cropperSettings.isBulk) {
        // If upload is in progress, don't handle close (handleBulkUploadComplete will handle it)
        if (this.bulkUploadInProgress) {
          return
        }

        // User cancelled - skip current file and continue with next
        this.currentBulkIndex++

        if (this.currentBulkIndex < this.bulkUploadQueue.length) {
          // Process next file
          this.$nextTick(() => {
            this.processNextBulkFile()
          })
        } else {
          // All files processed or cancelled
          this.isBulkUploading = false
          this.bulkUploadQueue = []
          this.bulkFiles = []
          this.currentBulkIndex = 0
          this.cropperSettings = {
            modalStatus: false,
            fileName: null,
            folder: null,
            ratio: null,
            type: null,
            isBulk: false,
            currentFile: null,
            bulkProgress: null,
          }
        }
      } else {
        this.cropperSettings = {
          modalStatus: false,
          fileName: null,
          folder: null,
          ratio: null,
          type: null,
          isBulk: false,
          currentFile: null,
          bulkProgress: null,
        }
      }
    },
    handleUploadImage(item) {
      if (this.cropperSettings.isBulk) {
        this.handleBulkUploadComplete(item)
      } else {
        this.setUploadImage(item)
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'products-gallery') {
        this.dataItem.images.push({
          id: null,
          title: null,
          filename: item.filename,
          thumb: item.thumb,
          filename_webp: item.filename_webp,
          thumb_webp: item.thumb_webp,
        })
      }
      this.cropperSettings.modalStatus = false
    },
    saveImage(data) {
      this.$store.dispatch('productGroups/saveImage', data)
    },
    removeImage(data, index) {
      if (data.id) {
        this.$store.dispatch('productGroups/removeImageData', data)
            .then(response => {
              if (response) {
                this.dataItem.images.splice(index, 1)
              }
            })
      } else {
        this.dataItem.images.splice(index, 1)
      }
    },
    triggerBulkUpload() {
      // Trigger file input click
      const fileInput = this.$refs.bulkFileInput
      if (fileInput && fileInput.$el) {
        const input = fileInput.$el.querySelector('input[type="file"]')
        if (input) {
          input.click()
        }
      }
    },
    handleBulkFilesChange(event) {
      const files = event.target.files || event.dataTransfer?.files
      if (!files || files.length === 0) {
        // Try to get from v-model
        if (this.bulkFiles && this.bulkFiles.length > 0) {
          this.handleBulkFiles(this.bulkFiles)
        }
        return
      }

      this.handleBulkFiles(files)
    },
    handleBulkFiles(files) {
      // Handle both FileList and Array
      let fileArray = []
      if (files instanceof FileList) {
        fileArray = Array.from(files)
      } else if (Array.isArray(files)) {
        fileArray = files
      } else if (files) {
        // Single file
        fileArray = [files]
      }

      if (fileArray.length === 0) return

      this.bulkUploadQueue = fileArray
      this.currentBulkIndex = 0
      this.isBulkUploading = true

      // Reset file input
      if (this.$refs.bulkFileInput) {
        this.$refs.bulkFileInput.$el.querySelector('input[type="file"]').value = ''
      }
      this.bulkFiles = []

      // Start processing the first file
      this.$nextTick(() => {
        this.processNextBulkFile()
      })
    },
    processNextBulkFile() {
      if (this.currentBulkIndex >= this.bulkUploadQueue.length) {
        // All files processed
        this.isBulkUploading = false
        this.bulkUploadQueue = []
        this.bulkFiles = []
        this.currentBulkIndex = 0
        return
      }

      const file = this.bulkUploadQueue[this.currentBulkIndex]
      this.setBulkModal('products-gallery', file)
    },
    setBulkModal(type, file) {
      if (type === 'products-gallery') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: file.name || 'products-post-image.jpg',
          folder: 'product_media',
          ratio: 800 / 1200,
          widthSize: 800,
          type: 'products-gallery',
          isBulk: true,
          currentFile: file,
          bulkProgress: {
            current: this.currentBulkIndex + 1,
            total: this.bulkUploadQueue.length,
          },
        }
      }
    },
    handleBulkUploadComplete(item) {
      if (this.cropperSettings.type === 'products-gallery') {
        this.dataItem.images.push({
          id: null,
          title: null,
          filename: item.filename,
          thumb: item.thumb,
          filename_webp: item.filename_webp,
          thumb_webp: item.thumb_webp,
        })
      }

      // Mark that we're processing the next file to prevent closeModal from interfering
      this.bulkUploadInProgress = true

      // Increment index and process next file
      this.currentBulkIndex++

      // Close current modal and process next file
      this.cropperSettings.modalStatus = false

      // Small delay to allow modal to close before opening next
      this.$nextTick(() => {
        this.bulkUploadInProgress = false
        this.processNextBulkFile()
      })
    },
  },
}
</script>
